<app-denials-multilevel *ngIf="!canHideMultiLevel"></app-denials-multilevel>
<app-denials *ngIf="canHideMultiLevel"></app-denials>
